"use client";
import { Hero } from "@/components/home/Hero";
import { Services } from "@/components/services/Services";
import { IndustryExpertise } from "@/components/industry-expertise/IndustryExpertise";
import { RecentWorks } from "@/components/recent-works/RecentWorks";
import { SoftwareService } from "@/components/software-service/SoftwareService";
import { DataStructureAndAnalysis } from "@/components/data-structure-and-analisis/DataStructureAndAnalysis";
import { MeetingImg } from "@/components/meeting-image/MeetingImg";
import { AppTools } from "@/components/scrolling-apps-tools/AppTools";
import { AwardsRecognition } from "@/components/awards/AwardsRecognition";
import { useSearchParams, useRouter } from "next/navigation";
import { useEffect, Suspense } from "react";
import { toast } from "sonner";

function UnsubscribeHandler() {
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    if (!searchParams) return;

    const unsubscribe = searchParams.get("unsubscribe");
    const email = searchParams.get("email");
    const leadType = searchParams.get("leadType");

    if (unsubscribe === "true" && email) {
      const callUnsubscribeApi = async () => {
        try {
          const response = await fetch(
            `https://sales-api.healthos.in/api/unsubscribe?email=${encodeURIComponent(
              email
            )}&leadType=${encodeURIComponent(leadType || "")}`
          );
          if (response.ok) {
            toast.success("Successfully unsubscribed from emails");
          } else {
            toast.error("Failed to unsubscribe");
          }
        } catch (error) {
          console.error("Error calling unsubscribe API:", error);
          toast.error("An error occurred while unsubscribing.");
        } finally {
          // Clear the URL query parameters after the API call finishes
          router.replace("/", { scroll: false });
        }
      };
      callUnsubscribeApi();
    }
  }, [searchParams, router]);

  return null;
}

export default function HomePage({
  locationName,
  serviceName,
  cmsSections = []
}: {
  locationName?: string;
  serviceName?: string;
  cmsSections?: any[];
}) {
  const renderSection = (section: any, index: number) => {
    if (section.show === false) return null;

    const props = { ...section.data, locationName, serviceName };
    const sectionKey = `${section.type}-${index}`;

    switch (section.type) {
      case 'hero-section':
      case 'hero':
        return <Hero key={sectionKey} {...props} />;
      case 'services':
        return <Services key={sectionKey} {...props} />;
      case 'industry-expertise':
        return <IndustryExpertise key={sectionKey} {...props} />;
      case 'recent-works':
        return <RecentWorks key={sectionKey} {...props} />;
      case 'software-service':
        return <SoftwareService key={sectionKey} {...props} />;
      case 'data-analysis':
        return <DataStructureAndAnalysis key={sectionKey} {...props} />;
      case 'meeting-image':
        return <MeetingImg key={sectionKey} {...props} />;
      case 'app-tools':
        return <AppTools key={sectionKey} {...props} />;
      case 'awards':
        return <AwardsRecognition key={sectionKey} {...props} />;
      default:
        return null;
    }
  };

  return (
    <main>
      <Suspense fallback={null}>
        <UnsubscribeHandler />
      </Suspense>

      {cmsSections.map((section, idx) => renderSection(section, idx))}
    </main>
  );
}



// import { Hero } from "@/components/home/Hero";
// import { Services } from "@/components/services/Services";
// import { IndustryExpertise } from "@/components/industry-expertise/IndustryExpertise";
// import { RecentWorks } from "@/components/recent-works/RecentWorks";
// import { SoftwareService } from "@/components/software-service/SoftwareService";
// import { DataStructureAndAnalysis } from "@/components/data-structure-and-analisis/DataStructureAndAnalysis";
// import { MeetingImg } from "@/components/meeting-image/MeetingImg";
// import { AppTools } from "@/components/scrolling-apps-tools/AppTools";

// export default function HomePage() {
//   return (
//     <main>
//       <Hero />
//       <Services />
//       <IndustryExpertise />
//       <RecentWorks title="Recent Works" />
//       <SoftwareService />
//       <DataStructureAndAnalysis />
//       <MeetingImg
//         image="/meeting_image/meeting.png"
//         text="BUILDING SUCCESS STARTS HERE—LET&apos;S DO IT TOGETHER." />
//       <AppTools />
//     </main>
//   );
// }
